import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  LinearBlur,
  Typography,
} from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import data from '../../../../../apps/web/public/data/users_faq.json'
import './terms.css'

interface ITermsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const TermsDialog = (props: ITermsDialogProps) => {
  const { open, onOpenChange } = props
  const { t } = useTranslate()
  const text = data?.data

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[450px] max-h-[80vh] overflow-hidden flex flex-col !px-0'>
        <DialogHeader className='flex flex-col gap-2xs'>
          <DialogTitle>{t('footer_terms_conditions')}</DialogTitle>
        </DialogHeader>
        <div className='min-w-[450px] flex-1 overflow-y-auto px-md mb-xl pb-3xl'>
          <div
            className='text-neutral-secondary'
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>
        <div className='flex justify-center items-center fixed bottom-0 left-0 right-0 p-md'>
          <LinearBlur
            steps={8}
            strength={64}
            falloffPercentage={100}
            tint='rgba(0, 0, 0, 0.1)'
            style={{
              position: 'absolute',
              height: '100px',
              width: '100%',
              bottom: 0,
            }}
            side='bottom'
          />
          <Button
            className='w-full z-10'
            variant='ghost'
            color='neutral'
            onClick={() => onOpenChange(false)}
          >
            {t('common_back')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>

    // <Dialog open={open} onOpenChange={onOpenChange}>
    //   <DialogContent className='max-w-full min-w-[450px] max-h-[80vh] overflow-hidden flex flex-col'>
    //     <DialogHeader>
    //       <DialogTitle>{t('footer_terms_conditions')}</DialogTitle>
    //     </DialogHeader>

    //     <div className='min-w-[450px] flex-1 overflow-y-auto px-md pb-20'>
    //       <div
    //         className='text-neutral-secondary'
    //         dangerouslySetInnerHTML={{ __html: text }}
    //       />
    //     </div>

    //     <div className='flex justify-center items-center fixed bottom-0 left-0 right-0 p-md'>
    //       <LinearBlur
    //         steps={8}
    //         strength={64}
    //         falloffPercentage={100}
    //         tint='rgba(0, 0, 0, 0.1)'
    //         style={{
    //           position: 'absolute',
    //           height: '100px',
    //           width: '100%',
    //           bottom: 0,
    //         }}
    //         side='bottom'
    //       />
    //       <Button
    //         className='w-full z-10'
    //         variant='ghost'
    //         color='neutral'
    //         onClick={() => onOpenChange(false)}
    //       >
    //         {t('common_back')}
    //       </Button>
    //     </div>
    //   </DialogContent>
    // </Dialog>
  )
}
